// extracted by mini-css-extract-plugin
export default {"tooltip_icon":"style_tooltip_icon__4DCrl"};